export default {
  activeTime: 'ActiveTime',
  addTime: 'AddTime',
  join: 'Join',
  bit: 'Bit',
  cancel: 'Cancel',
  connectError: 'Connect error',
  connectOK: 'Connect OK',
  copy: 'Copy',
  copyError: 'Copy error',
  copyOK: 'Copy OK',
  delete: 'Delete',
  deleteError: 'Delete error',
  deleteOK: 'Delete OK',
  uninstallText: 'Uninstall command',
  uninstallURL: 'https://github.com/openp2p-cn/openp2p/blob/master/USAGE.md#uninstall',
  device: 'Devices',
  network: 'Network',
  deviceName: 'Name',
  edit: 'Edit',
  editing: 'Editing',
  email: 'Email',
  install: 'Install',
  lanip: 'Lan IP',
  latestVer: 'Latest ver',
  login: 'Sign in',
  loginError: 'Sign in error',
  logout: 'Sign out',
  offline: 'Offline',
  ok: 'OK',
  online: 'Online',
  optional: '(optional)',
  os: 'OS',
  p2papp: 'Apps',
  phone: 'Phone',
  profile: 'Profile',
  reboot: 'Reboot',
  refresh: 'Refresh',
  regTime: 'RegisterTime',
  requesting: 'Requesting...',
  requestTimeout: 'Request timed out, please try again later',
  tokenExpired: 'Token is invalid, please sign in again',
  save: 'Save',
  saveError: 'Failed to save',
  saveOK: 'Saved successfully',
  search: 'Search',
  sharebw: 'ShareBandwidth',
  update: 'Update',
  version: 'Version',
  wanip: 'Wan IPv4',
  total1: 'Established connections for users:',
  send: 'Send verify code',
  sendVerificationCodeOK: 'The verification code has been sent successfully, please check your email',
  sendVerificationCodeError: 'Failed to send verification code',
  emailInvalidError: 'Email not registered',
  confirm: 'Confirm',
  invalidCharacter: 'Invalid character',
  pro: {
    errReq: 'Failed to obtain profile',
    info: '\'s Profile',
  },
  inst: {
    linuxDesc: 'according to you enviroment, choose ONE install comand below:',
    linuxDescSh: '1. Execute the following command in the shell, you need root privileges',
    linuxDescWrt: '2. Use the following when there is no sudo, curl or bash (OpenWRT)',
    linuxDescDocker: '3. Use Docker to run in the container (note that the latest version used here may not be able to get the latest version due to local cache. You need to manually execute "docker pull openp2pcn/openp2p-client:latest" or change "latest" to a specified tag',
    win10warn: 'Since this is a free project, without purchasing a Microsoft certificate to sign the program, Windows will prevent it from running by default, and you can select "Run anyway"',
    windowsDesc: 'Download Windows client, one-key installation',
    download: 'Download',
    androidDesc: 'Open with your mobile browser, click to download and install',
  },
  apps: {
    diffVer: 'Versions are inconsistent, and P2P applications may not be established. It is recommended to upgrade to the latest version.',
    direct: 'Direct',
    directIPv4: 'IPv4 Direct',
    directIPv6: 'IPv6 Direct',
    directIntranet: 'Intranet',
    dstHost: 'Remote IP',
    dstPort: 'Remote port',
    whitelist: 'White list',
    errNotChosen: 'Please choose a remote device',
    errPortRange: 'Port range in 0-65535',
    hasBeen: 'has been occupied by【',
    link: 'Link',
    localNode: 'Local device',
    localPort: 'Local port',
    name: 'APPName',
    new: 'New APP',
    noApp: 'This device has no App',
    occupy: '】',
    pleaseChoose: 'Please choose',
    port: 'Port',
    privateNet: 'Private Network',
    protocol: 'Protocol',
    publicNet: 'Public Network',
    relay: 'Relay',
    relayNode: 'RelayNode',
    remoteNode: 'Remote device',
    remoteService: 'Remote service',
    title: '\'s all App',
    tooLong: 'The length of the application name should not exceed 32 characters',
    connecting: 'Connecting...',
    disabled: 'Disabled',
    connectTime: 'Connect Time',
    whitelistTips1: 'Example1: 127.0.0.1,192.168.1.0/24,10.1.1.30-10.1.1.50',
    whitelistTips2: 'Example2: 127.0.0.1 （local access only）',
    whitelistTips3: 'Example3: 192.168.1.0/24',
    whitelistTips4: 'Example4: 192.168.3.100-192.168.3.255',
    androidListenPortTooLow: "Android devices may fail if the listening local port is less than 10000"
  },
  nodes: {
    atleast2: 'You need to install OpenP2P on at least two devices, and then create a P2P application, you can directly access',
    nameTooShort: 'Device name cannot be less than 8 characters',
    nonode: 'No client installed',
    operationError: 'Operation error',
    operationOK: 'Operation done',
    pushUpgradeError: 'Push upgrade error',
    pushUpgradeOK: 'Push upgrade ok',
    androidManualUpgrade: 'Android App need to reinstall manually with latest verson',
    natType: 'NAT Type',
  },
  reg: {
    newUser: 'Create an account',
    forgotPwd: 'Forgot password?',
    forgotPwdDetail: 'Join QQ group 16947733 contact group owner',
    noAuth: '(No mobile phone or email authentication required)',
    noUser: 'New to OpenP2P? ',
    password: 'Password',
    passwordConfirm: 'Confirm Password',
    pwdDiff: 'The passwords entered twice do not match, please re-enter',
    register: 'Register',
    registerError: 'Register error',
    registerOK: 'Register OK',
    resetPwdError: 'Reset password error',
    resetPwdOK: 'Reset password OK',
    title: 'Register',
    tooShort: 'Username and password length cannot be less than 8 charaters',
    username: 'UserName',
    emailTips: 'Retrieve the password',
    resetPwd: 'Reset password',
    verifyCode: 'Verification Code',
    userBeenUsed: 'User name has been registered',
    emailOrPhoneBeenUsed: 'Email or phone has been registered',
    verificationCodeError: 'Verification code error',
    agreeTerms: 'Read and Agree',
    userAgreement: 'User Agreement',
    agreeTermsFirst: 'Please check to agree to the User Agreement first',
    agreementDetail: 'This project is open source for everyone to learn and use for free. It is forbidden to be used for illegal purposes. Any loss caused by improper use of this project or accident, this project and related personnel will not bear any responsibility.',
  },
  sdwan: {
    tabName: 'SDWAN',
    member: 'Member',
    virtualIP: 'Virutal IP',
    gateway: 'Gateway',
    resource: 'Resources*',
    resourceTips: 'Default is empty. Setting up network resources allows other members to access the entire LAN. <br>Example:192.168.3.0/24<br>(currently only supports linux system)',
    control: 'Control',
    myNetwork: 'My Network',
    tooManyMembers: 'The number of members cannot exceed 5',
    versionLow: 'The selected device version is too low, please upgrade to the latest version',
    connectStatus: 'Status',
    detail: 'Detail',
    fullmeshMode: 'Fullmesh',
    centralMode: 'Central',
    centralNode: 'CentralNode',
    specifiedRelayNode: 'Specified relay node',
    notSpecified: 'Not specified',
    forceRelay: 'Force relay',
    chooseSDWANMember: 'Please choose',
    modeTips: 'P2P mode: Fullmesh connection, that is, each node will connect to all other nodes, only suitable for networks with a small number of members<br> Central mode: Each member will only connect to the central node, and members will not be interconnected; suitable for members There are many members who are stable online and can easily establish P2P connections (such as cloud hosts)',
    centralTips: 'Please choose a member that is stable online and easy to establish a P2P connection (such as a cloud host). If you have a public IP, be sure to allow the TCPPort port in config.json',
    centralModeNotSpecifiedNode: 'Central mode must specify a central node',
    diffVer: 'The versions of each member are inconsistent and communication may not be possible. It is recommended that all members upgrade to the latest version',
  }
}